import React, { useEffect } from "react";
import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { Usuario, Empresa } from "../components/Manual/ImagenData";

import HeaderHome from "../layout/HeaderHome";
import FooterHome from "../layout/FooterHome";

import blog1 from "../static/images/Blog-1.png";
import blog2 from "../static/images/Blog-2.png";
import blog3 from "../static/images/Blog-3.png";

function Faq() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const history = useHistory();

  function EnviarEmail(values) {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };
    axios
      .post("faq/pregunta", JSON.stringify(values), config)
      .then((result) => {
        if (result.status === 200) {
          // alert(result.data.message);
          toast.success(result.data.message, {
            duration: 4000,
          });
        }
      })
      .catch(function (error) {
        if (!error.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        } else if (error.response.status === 400) {
          toast.error(error.response.data.message);
        } else if (error.request) {
        }
      });
  }
  const Validaciones = Yup.object().shape({
    nombre: Yup.string().required("No puede estar vacio"),
    pregunta: Yup.string().required("No puede estar vacio"),
    email: Yup.string().required("No puede estar vacio"),
  });

  return (
    <Fragment>
      <HeaderHome></HeaderHome>
      <section id="hero" className="fqa">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-10 px-0">
              <div className="fqa__wrapper fqa__js">
                <div className="fqa__item">
                  <div className="fqa__itemWrapper">
                    <div className="fqa__center">
                      <div className="fqa__title">PREGUNTAS FRECUENTES</div>
                      <div className="fqa__content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="preguntas-frecuentes">
        <div className="container">
          <div className="row">
            <div className="accordion" id="accordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingManual">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseManual"
                    aria-expanded="true"
                    aria-controls="collapseManual"
                  >
                    Manual
                  </button>
                </h2>
                <div
                  id="collapseManual"
                  className="accordion-collapse collapse"
                  aria-labelledby="#headingManual"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    <div className="row btnManual ">
                      <div className="col-3">
                        <button
                          target="_blank"
                          onClick={() =>
                            window.open("/ManualUsuario", "_blank")
                          }
                          className="btn btn--gradient btnManual"
                        >
                          <i className="fas fa-user-circle"></i> Usuario
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          onClick={() =>
                            window.open("/ManualEmpresa", "_blank")
                          }
                          className="btn btn--gradient btnManual"
                        >
                          <i className="fas fa-building-o"></i> Empresa
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    ¿Qué es plataforma KREZCO?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="#headingOne"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    <p>
                      Es un portal digital que conecta el talento humano con
                      empresas de prestigio y centros de formación para crear
                      relaciones perdurables.
                    </p>
                    <p>
                      KREZCO es parte del proyecto EMPUJE, liderado por Children
                      Believe y enfocado en el cierre de la brecha de género en
                      la empleabilidad juvenil.
                    </p>
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    ¿A quiénes está dirigida la plataforma KREZCO?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    La plataforma KREZCO forma parte del proyecto EMPUJE, está
                    dirigida a los jóvenes que forman parte de este programa y
                    que han culminado con éxito los módulos de formación en
                    habilidades para la vida y habilidades profesionales con
                    enfoque de género.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    ¿Cómo me puedo registrar?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    En la página de Inicio debes seleccionar registro y seguir
                    las indicaciones.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    ¿En cuánto tiempo voy a encontrar un trabajo si me registro
                    en KREZCO?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    Al registrarte en la plataforma KREZCO tendrás acceso a que
                    las mejores empresas del país vean tu curriculum y con ello
                    tener la oportunidad de ser contratado. No podemos darte un
                    tiempo preciso, pero si eres parte de esta comunidad tienes
                    un alto porcentaje de encontrar un empleo.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    ¿Cómo puedo saber si alguna empresa ha visto mi hoja de
                    vida?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    En tu perfil podrás darle seguimiento a todas las
                    aplicaciones que hayas hecho.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    ¿Cuál es la diferencia entre usuario EMPUJE y uno público?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    Si eres un joven EMPUJE podrás navegar por todas las partes
                    del portal, participar en los diferentes grupos, recibir
                    alertas de trabajo o de cursos de formación profesional que
                    sean de tu interés. Si no eres un joven EMPUJE solo podrás
                    navegar por la página de INICIO.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                  >
                    ¿Olvidé mi contraseña ¿Qué debo hacer?
                  </button>
                </h2>
                <div
                  id="collapseSeven"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingSeven"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    Ingresa en el enlace olvidé mi contraseña y recibirás un
                    correo con las instrucciones a seguir.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEight">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEight"
                    aria-expanded="false"
                    aria-controls="collapseEight"
                  >
                    ¿Cómo puedo acceder a una pasantía?
                  </button>
                </h2>
                <div
                  id="collapseEight"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingEight"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    Al formar parte de KREZCO podrás llenar tu perfil de
                    candidato y seleccionar la opción “pasante” como tipo de
                    contratación.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNine">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseNine"
                    aria-expanded="false"
                    aria-controls="collapseNine"
                  >
                    ¿Conseguí un puesto de trabajo, puedo seguir siendo parte de
                    la plataforma KREZCO?
                  </button>
                </h2>
                <div
                  id="collapseNine"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingNine"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    Si, en KREZCO puedes encontrar cursos de formación
                    profesional que ayuden a tu desarrollo profesional o
                    encontrar otro puesto de trabajo que satisfaga mejor tus
                    necesidades.
                  </div>
                </div>
              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTen"
                    aria-expanded="false"
                    aria-controls="collapseTen"
                  >
                    ¿Puedo aplicar a una vacante si tengo menos de 18 años?
                  </button>
                </h2>
                <div
                  id="collapseTen"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTen"
                  data-bs-parent="#accordion"
                >
                  <div className="accordion-body">
                    El proyecto EMPUJE se ajusta a la legislación nacional. Por
                    lo que si estás entre los 15 y 16 años se requiere el
                    consentimiento de tu madre, padre o tutor para que puedas
                    trabajar. Siguiendo con el marco legal del país y las
                    políticas internas de Children Believe, trabajaremos porque
                    tu empleo o emprendimiento sea flexible para que no afecte
                    tu vida familiar, tus estudios y que no ponga en riesgo tu
                    salud física, emocional, como también, que estés libre de
                    todo tipo de abuso.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Formik
        initialValues={{
          nombre: "",
          email: "",
          pregunta: "",
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          EnviarEmail(values);
          setSubmitting(false);
          resetForm();
        }}
        validationSchema={Validaciones}
      >
        {({ errors, touched, isSubmitting }) => (
          <section className="contactenos">
            <div className="container">
              <div className="row">
                <div className="title">Contáctenos</div>
                <div className="col-8 bg-content">
                  <Form>
                    <div className="row">
                      <div className="col">
                        <label>Nombre</label>
                        <Field
                          id="nombre"
                          name="nombre"
                          type="text"
                          className="form-control"
                        ></Field>
                        {errors.nombre && touched.nombre && (
                          <span className="form__validation form__validation--error">
                            {errors.nombre}
                          </span>
                        )}
                      </div>
                      <div className="col">
                        <label>Correo Electrónico</label>
                        <Field
                          id="email"
                          name="email"
                          type="email"
                          className="form-control"
                        ></Field>
                        {errors.email && touched.email && (
                          <span className="form__validation form__validation--error">
                            {errors.email}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>Ingresa tu pregunta</label>
                        <Field
                          as="textarea"
                          id="pregunta"
                          name="pregunta"
                          className="md-textarea form-control"
                          rows="8"
                        ></Field>
                        {errors.pregunta && touched.pregunta && (
                          <span className="form__validation form__validation--error">
                            {errors.pregunta}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row mt-4">
                      <div className="col">
                        <button
                          disabled={isSubmitting}
                          type="submit"
                          className="btn btn--gradient"
                        >
                          Enviar
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </section>
        )}
      </Formik>
      <Toaster />
      <section className="news">
        {/*<div className="title">Últimas Publicaciones</div>
        <div className="container" >      
        <div className="row">                   
          <div className="leerMas">                       
              <a href="https://cep.empuje.org/blog/" target="_blank"  > Leer Mas</a>
            </div>
	</div>
	</div>

       
        <div className="container">
          <div className="title">Últimas publicaciones</div>
          <div className="row">
            <div className="col-sm-4">
              <img src={blog1}></img>
              <span>10 de Octubre, 2020</span>
              <h2>Guía para preparar una Entrevista de Trabajo</h2>
              <p>
                Prepara tu próxima entrevista, utiliza nuestra guía e informate
                de qué preguntas te pueden hacer y cómo responderlas, qué no
                debes decir, cómo explicar tus áreas a mejorar, qué preguntas
                puedes hacer, entre otros.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog2}></img>
              <span>09 de Octubre, 2020</span>
              <h2>
                Lista de control de <span>diversidad e inclusión</span>
              </h2>
              <p>
                La diversidad y la inclusión se mencionan a menudo en la misma
                frase, porque una organización inclusiva no puede existir sin
                uan fuerza de trabajo diversa. Y una organización debe ser
                inclusiva a fin de mantener su personal diverso.
              </p>
              <a href="#">Leer más</a>
            </div>

            <div className="col-sm-4">
              <img src={blog3}></img>
              <span>12 de Octubre, 2020</span>
              <h2>Diseña tu plan de carrera</h2>
              <p>
                El plan de carrera es una estrategia empresarial para conseguir
                talento valioso para las compañias. Te damos a conocer los
                secretos de esta táctica para poder ponerla en práctica.
              </p>
              <a href="#">Leer más</a>
            </div>
          </div>
        </div>
        */}
      </section>
      <FooterHome></FooterHome>
    </Fragment>
  );
}

export default Faq;
